import setPromiseState from '../../utils/promiseState';
import actionTypes from './ActioTypes';
import InitState from './InitState';

export default (state = InitState, actions) => {
  switch (actions.type) {
    case actionTypes.ON_MAIN_CLICK:
      return {...state, onMainClick: !state.onMainClick};

    case actionTypes.GET_ALL_CITIES.pending:
      return {...state, promise: {...state.promise, getCities: {...setPromiseState(true, false, false)}}};
    case actionTypes.GET_ALL_CITIES.rejected:
      return {...state, error: actions.data || {}, promise: {...state.promise, getCities: {...setPromiseState(false, false, true)}}};
    case actionTypes.GET_ALL_CITIES.fulfilled: {
      return {...state, cities: actions.data, promise: {...state.promise, getCities: {...setPromiseState(false, true, false)}}};
    }

    case actionTypes.GET_CATEGORIES.pending:
      return {...state, promise: {...state.promise, getTourCategories: {...setPromiseState(true, false, false)}}};
    case actionTypes.GET_CATEGORIES.rejected:
      return {...state, error: actions.data || {}, promise: {...state.promise, getTourCategories: {...setPromiseState(false, false, true)}}};
    case actionTypes.GET_CATEGORIES.fulfilled: {
      return {...state, tourCategories: actions.data, promise: {...state.promise, getTourCategories: {...setPromiseState(false, true, false)}}};
    }

    case actionTypes.CONTACT_US.pending:
      return {...state, promise: {...state.promise, contactUs: {...setPromiseState(true, false, false)}}};
    case actionTypes.CONTACT_US.rejected:
      return {...state, error: actions.data || {}, promise: {...state.promise, contactUs: {...setPromiseState(false, false, true)}}};
    case actionTypes.CONTACT_US.fulfilled: {
      return {...state, promise: {...state.promise, contactUs: {...setPromiseState(false, true, false)}}};
    }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/Main/Reducer.js